import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SkipBlockerRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SkipBlockerResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const skipBlocker = (request: SkipBlockerRequest, options?: CashRequestOptions) =>
  post<SkipBlockerRequest, SkipBlockerResponse>('/2.0/cash/skip-blocker', request, { ...options, rejectOnError: true })
